// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconCoinNumber = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '38',
      height: '38',
      viewBox: '0 0 38 38',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.4406 12.0907C13.6678 7.32281 17.9959 3.7998 23.1469 3.7998C29.2521 3.7998 34.2014 8.74909 34.2014 14.8543C34.2014 19.7218 31.0555 23.8546 26.686 25.3302M12.4406 27.1154H14.8534M14.8534 27.1154H17.0988M14.8534 27.1154V18.3064C14.8534 18.3064 13.169 19.4644 12.0897 20.2064M25.9079 23.1453C25.9079 29.2505 20.9586 34.1998 14.8534 34.1998C8.74812 34.1998 3.79883 29.2505 3.79883 23.1453C3.79883 17.04 8.74812 12.0907 14.8534 12.0907C20.9586 12.0907 25.9079 17.04 25.9079 23.1453Z',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconCoinNumber };
